export const PUSH_STATE = "PUSH_STATE"
export const POP_STATE = "POP_STATE"
export const CLEAR_STATE = "CLEAR_STATE"
